import React from "react"
import Link from "next/link"
import styled from "styled-components"

import { FAQ_CATEGORIES } from "~/components/faq/constants"
import WinItButtonBase from "~/components/WinItButton"

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${props => props.theme.media.mobile`
    flex-direction: column;
  `};
`

const LinkContainer = styled.div`
  margin: 5px;
  max-width: 450px;
  width: 100%;
`

const Categories = () => {
  return (
    <Container>
      {FAQ_CATEGORIES.map(cat => {
        return (
          <LinkContainer key={cat.category}>
            <Link href="/faq/[category]" as={`/faq/${cat.slug}`} passHref>
              <WinItButtonBase
                color={cat.color}
                width="100%"
                as="a"
              >
                {cat.title}
              </WinItButtonBase>
            </Link>
          </LinkContainer>
        )
      })}
    </Container>
  )
}

export default Categories
